import { assign, createMachine, Interpreter } from 'xstate-v4'
import { reportError } from '~/utility/reportError'
import { PaymentCard } from './schema'

export interface SavedPaymentCardsContext {
  savedCards: PaymentCard[]
}

function getContextInitial(): SavedPaymentCardsContext {
  return {
    savedCards: [],
  }
}

interface Schema {
  states: {
    initialState: {}
    loading: {}
    error: {}
    loaded: {}
  }
}

export function returnSavedPaymentCardsStateMachine() {
  return createMachine<SavedPaymentCardsContext>(
    {
      id: 'savedPaymentCards',
      context: getContextInitial(),
      initial: 'initialState',
      states: {
        initialState: {
          always: 'loading',
        },
        loading: {
          invoke: {
            src: 'loadSavedCards',
            onDone: {
              target: 'loaded',
              actions: assign({
                savedCards: (_, { data }) => data,
              }),
            },
            onError: {
              target: 'error',
              actions: 'logError',
            },
          },
        },
        error: {},
        loaded: { type: 'final' },
      },
    },
    {
      actions: {
        logError: (_, { data }: any) =>
          reportError(data, { machine: 'savedPaymentCards' }),
      },
    },
  )
}

export type savedPaymentCardsMachineInterpreter = Interpreter<
  SavedPaymentCardsContext,
  Schema
>
